<template>
  <v-data-table
    item-key="id"
    :headers="headers"
    :loading="loading"
    :items="items"
    :items-per-page="10"
    :footer-props="{'items-per-page-text': 'Số lớp một trang'}"
    disable-sort
    :server-items-length="count"
    v-bind="$attrs"
    :options.sync="pagination"
  >
    <template v-slot:[`footer.page-text`]="items">
      Lớp thứ {{ items.pageStart }} - {{ items.pageStop }} trên tổng {{ items.itemsLength }} lớp
    </template>

    <template v-slot:[`item.actions`]="{item}">
      <v-btn v-if="item.canUpdate" @click="() => onUpdate(item)" color="admin" outlined>Cập nhật</v-btn>
    </template>
  </v-data-table>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
const baseHeaders = [
  {text: 'Tên lớp', value: 'title'},
  {text: 'Khối', value: 'type', align: 'center'},
  {text: 'Cơ sở', value: 'department'},
  {text: 'Sĩ số giới hạn', value: 'limit', align: 'center'},
  {text: 'SL xếp lớp', value: 'count', align: 'center'},
  {text: 'SL xếp lớp & nhập học', value: 'enrollCount', align: 'center'},
]

export default {
  computed: {
    ...mapGetters({
      user: 'auth/user',
      items: 'enrollClass/items',
      count: 'enrollClass/count',
      filterParams: 'enrollClass/filterParams',
    }),
    canConfig() {
      return this.$helpers.ALLOWED_SETTING_ENROLL_PLAN.includes(this.user.username)
    },
    headers() {
      const res = [...baseHeaders]
      if (this.canConfig) res.push({text: 'Thao tác', value: 'actions', align: 'center'})
      return res
    },
  },
  data: () => ({loading: false, pagination: {}}),
  watch: {
    pagination: {
      async handler(newOptions, oldOptions) {
        if (newOptions && oldOptions) {
          await this.refresh((newOptions.page - 1) * newOptions.itemsPerPage, newOptions.itemsPerPage)
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    ...mapActions({fetchItems: 'enrollClass/fetchItems'}),
    getBaseQuery() {
      let query = {}
      if (this.user.department === 'both') {
        if (!Object.keys(this.filterParams).includes('department_in'))
          query.department_in = ['Cơ sở A', 'Cơ sở 1', 'unset']
      } else query.department_in = [this.user.department, 'unset']
      return query
    },
    async refresh(_start = 0, _limit = 10) {
      this.loading = true
      await this.fetchItems({_start, _limit, ...this.getBaseQuery()})
      this.loading = false
    },
    onUpdate(item) {
      this.$emit('onUpdate', {...item, isEdit: true})
    },
  },
}
</script>
